import React, { useState } from "react";
import '../styles/Comisiones.css';

/*Imagenes*/
import Jose_img from '../imagenes/concejoMunicipal/alcalde.png';
import Froilan_img from '../imagenes/concejoMunicipal/Froilan_03.png';
import Zunita_img from '../imagenes/concejoMunicipal/Zunita_03.png';
import Tito_img from '../imagenes/concejoMunicipal/Tito_03.png';
import Eberardo_img from '../imagenes/concejoMunicipal/Eberardo_03.png';
import Nancy_img from '../imagenes/concejoMunicipal/Nancy_03.png';
import Fredy_img from '../imagenes/concejoMunicipal/Fredy_03.png';
import David_img from '../imagenes/concejoMunicipal/David_03.png';
import Wilbert_img from '../imagenes/concejoMunicipal/Wilbert_03.png';
import Aydee_img from '../imagenes/concejoMunicipal/Aydee_03.png';


const comisionesData = [
  {
    id: 1,
    nombre: "Comisión Ordinaria de Administración",
    descripcion: "Tiene como finalidad supervisar, evaluar y proponer acciones orientadas al adecuado manejo de los recursos humanos, materiales y financieros de la municipalidad.",
    integrantes: [
      {
        nombre: "Ing. David Vilca Elme",
        cargo: "Presidente",
        foto: David_img
      },
      {
        nombre: "Tec. Fredy Willams Molina Mendoza",
        cargo: "Vicepresidente",
        foto: Fredy_img
      },
      {
        nombre: "Tec. Eberardo Ataucuri Alvis",
        cargo: "Secretario",
        foto: Eberardo_img
      }
    ]
  },
  {
    id: 2,
    nombre: "Comisión Ordinaria de Desarrollo Económico",
    descripcion: "Tiene por objetivo fomentar el crecimiento económico local a través del impulso de actividades productivas, comerciales y de emprendimiento.",
    integrantes: [
      {
        nombre: "Bach. Wilbert Sapacayo Sapacayo.",
        cargo: "Presidente",
        foto: Wilbert_img
      },
      {
        nombre: "Ing. David Vilca Elme",
        cargo: "Vicepresidente",
        foto: David_img
      },
      {
        nombre: "Med. Zunita Zevallos Ugarte.",
        cargo: "Secretaria",
        foto: Zunita_img
      }
    ]
  },
  {
    id: 3,
    nombre: "Comisión Ordinaria de Desarrollo Social",
    descripcion: "Vela por el bienestar integral de la población, impulsando programas sociales orientados a mejorar la calidad de vida, la inclusión y la equidad.",
    integrantes: [
      {
        nombre: "Med. Zunita Zevallos Ugarte.",
        cargo: "Presidenta",
        foto: Zunita_img
      },
      {
        nombre: "Bach. Wilbert Sapacayo Sapacayo.",
        cargo: "Vicepresidente",
        foto: Wilbert_img
      },
      {
        nombre: "Prof. Tito Ronald Baca Yallerco",
        cargo: "Secretario",
        foto: Tito_img
      }
    ]
  },
  {
    id: 4,
    nombre: "Comisión Ordinaria de Planeamiento y Presupuesto",
    descripcion: "Es responsable de analizar, coordinar y dar seguimiento a la formulación, ejecución y evaluación del presupuesto municipal.",
    integrantes: [
      {
        nombre: "Ing. Aydee Laime Mendoza",
        cargo: "Presidenta",
        foto: Aydee_img
      },
      {
        nombre: "Prof. Tito Ronald Baca Yallerco",
        cargo: "Vicepresidente",
        foto: Tito_img
      },
      {
        nombre: "Tec. Fredy Willams Molina Mendoza",
        cargo: "Secretario",
        foto: Fredy_img
      }
    ]
  },
  {
    id: 5,
    nombre: "Comisión Ordinaria de Desarrollo Territorial y Mantenimiento Vial Provincial",
    descripcion: "Se encarga de promover y supervisar las acciones relacionadas con el ordenamiento territorial, el desarrollo urbano y rural, así como el mantenimiento y mejoramiento de la infraestructura vial provincial.",
    integrantes: [
      {
        nombre: "Tec. Fredy Willams Molina Mendoza",
        cargo: "Presidente",
        foto: Fredy_img
      },
      {
        nombre: "Tec. Nancy Salhua Janampa",
        cargo: "Vicepresidenta",
        foto: Fredy_img
      },
      {
        nombre: "Ing. Aydee Laime Mendoza",
        cargo: "Secretaria",
        foto: Aydee_img
      }
    ]
  },
  
  {
    id: 6,
    nombre: "Comisión Ordinaria de Servicios Municipales y Gestión Ambiental",
    descripcion: "Tiene como propósito supervisar y mejorar la prestación de los servicios básicos municipales, tales como limpieza pública, recojo de residuos sólidos, agua y saneamiento.",
    integrantes: [
      {
        nombre: "Tec. Eberardo Ataucuri Alvis",
        cargo: "Presidente",
        foto: Eberardo_img
      },
      {
        nombre: "Sr. Froilán Batállanos Ibarra",
        cargo: "Vicepresidente",
        foto: Froilan_img
      },
      {
        nombre: "Ing. David Vilca Elme",
        cargo: "Secretario",
        foto: David_img
      }
    ]
  },
  {
    id: 7,
    nombre: "Comisión Ordinaria de Infraestructura",
    descripcion: "Se encarga de evaluar, priorizar y fiscalizar las obras públicas ejecutadas por la municipalidad.",
    integrantes: [
      {
        nombre: "Sr. Froilán Batállanos Ibarra",
        cargo: "Presidente",
        foto: Froilan_img
      },
      {
        nombre: "Tec. Eberardo Ataucuri Alvis",
        cargo: "Vicepresidente",
        foto: Eberardo_img
      },
      {
        nombre: "Bach. Wilbert Sapacayo Sapacayo",
        cargo: "Secretario",
        foto: Wilbert_img
      }
    ]
  },
  {
    id: 8,
    nombre: "Comisión Ordinaria de Formulación, Supervisión y Liquidación de Proyectos",
    descripcion: "Tiene la responsabilidad de revisar y fiscalizar los procesos de formulación, ejecución, supervisión y cierre de proyectos municipales.",
    integrantes: [
      {
        nombre: "Prof. Tito Ronald Baca Yallerco",
        cargo: "Presidente",
        foto: Tito_img
      },
      {
        nombre: "Med. Zunita Zevallos Ugarte",
        cargo: "Vicepresidenta",
        foto: Zunita_img
      },
      {
        nombre: "Tec. Nancy Salhua Janampa",
        cargo: "Secretaria",
        foto: Nancy_img
      }
    ]
  }, 
  {
    id: 9,
    nombre: "Comisión Ordinaria de Administración Tributaria",
    descripcion: "Tiene como función supervisar, evaluar y proponer medidas que fortalezcan la gestión de los ingresos municipales, especialmente aquellos provenientes de tributos, tasas y contribuciones.",
    integrantes: [
      {
        nombre: "Tec. Nancy Salhua Janampa",
        cargo: "Presidenta",
        foto: Nancy_img
      },
      {
        nombre: "Ing. Aydee Laime Mendoza",
        cargo: "Vicepresidenta",
        foto: Aydee_img
      },
      {
        nombre: "Sr. Froilán Batállanos Ibarra",
        cargo: "Secretario",
        foto: Froilan_img
      }
    ]
  }
];


function Comisiones() {
  const [modalOpen, setModalOpen] = useState(false);
  const [comisionSeleccionada, setComisionSeleccionada] = useState(null);

  const abrirModal = (comision) => {
    setComisionSeleccionada(comision);
    setModalOpen(true);
  };

  const cerrarModal = () => {
    setModalOpen(false);
    setTimeout(() => setComisionSeleccionada(null), 300);
  };

  return (
    <div className="container">
      <h1 className="titulo">COMISIONES ORDINARIAS MUNICIPALES 2025</h1>
      <div className="tarjetas">
        {comisionesData.map((comision) => (
          <div
            key={comision.id}
            className="tarjeta"
            onClick={() => abrirModal(comision)}
          >
            <h2>{comision.nombre}</h2>
            <p>{comision.descripcion}</p>
            <a>Ver Integrantes</a>
          </div>
        ))}
      </div>

      {modalOpen && comisionSeleccionada && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div
            className="modal-contenido"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="cerrar-btn" onClick={cerrarModal}>
              ✖
            </button>
            <h2>{comisionSeleccionada.nombre}</h2>
            <div className="integrantes">
              {comisionSeleccionada.integrantes.map((persona, index) => (
                <div key={index} className="tarjeta-integrante">
                  <img src={persona.foto} alt={persona.nombre} />
                  <h3>{persona.nombre}</h3>
                  <p>{persona.cargo}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Comisiones;
